export const FirebaseConfig = {
    apiKey: "AIzaSyBTNi9UXy9iWmOElC2TyAZnaw9PvQYC0C4",
    authDomain: "imphalcab-69cbe.firebaseapp.com",
    databaseURL: "https://imphalcab-69cbe-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "imphalcab-69cbe",
    storageBucket: "imphalcab-69cbe.firebasestorage.app",
    messagingSenderId: "245091918547",
    appId: "1:245091918547:web:bc6256f5d98cec6a95ea26",
    measurementId: "G-NLFCMQXFFH"
};
